module.exports = __webpack_public_path__ + "static/shore-white-095b09b9703657891c7fba85cfc74165.png";